<div class="archived-items-skeleton__desktop tw-mt-4">
  <div class="tw-grid tw-items-center tw-bg-gray-50 tw-border-b tw-border-gray-200 archived-items-skeleton__header">
    <div class="tw-flex tw-items-center tw-justify-center tw-px-3 tw-py-3">
      <ngx-skeleton-loader count="1" [theme]="theme('20px', '20px')" animation="pulse"></ngx-skeleton-loader>
    </div>
    @for (_ of [1, 2, 3, 4, 5]; track $index) {
      <div class="tw-px-4 tw-py-3">
        <ngx-skeleton-loader count="1" [theme]="theme('80px', '12px')" animation="pulse"></ngx-skeleton-loader>
      </div>
    }
  </div>

  @for (_ of rows; track $index) {
    <div
      class="tw-grid tw-items-center tw-border-b tw-border-gray-200 last:tw-border-b-0 archived-items-skeleton__row"
      [ngClass]="$even ? 'tw-bg-white' : 'tw-bg-gray-50'"
    >
      <div class="tw-flex tw-items-center tw-justify-center tw-px-3 tw-py-4">
        <ngx-skeleton-loader count="1" [theme]="theme('20px', '20px')" animation="pulse"></ngx-skeleton-loader>
      </div>
      <div class="tw-px-4 tw-py-4">
        <ngx-skeleton-loader count="1" [theme]="theme('70%', '14px')" animation="pulse"></ngx-skeleton-loader>
      </div>
      <div class="tw-px-4 tw-py-4">
        <ngx-skeleton-loader count="1" [theme]="theme('60px', '20px', '6px')" animation="pulse"></ngx-skeleton-loader>
      </div>
      <div class="tw-px-4 tw-py-4">
        <ngx-skeleton-loader count="1" [theme]="theme('90px', '14px')" animation="pulse"></ngx-skeleton-loader>
      </div>
      <div class="tw-px-4 tw-py-4">
        <ngx-skeleton-loader count="1" [theme]="theme('80%', '14px')" animation="pulse"></ngx-skeleton-loader>
      </div>
      <div class="tw-px-4 tw-py-4">
        <ngx-skeleton-loader count="1" [theme]="theme('20px', '20px', '9999px')" animation="pulse"></ngx-skeleton-loader>
      </div>
    </div>
  }
</div>

<div class="archived-items-skeleton__mobile">
  @for (_ of rows; track $index) {
    <div class="tw-flex tw-flex-col tw-gap-3 tw-bg-white tw-border tw-border-gray-200 tw-rounded-lg tw-p-4">
      <div class="tw-flex tw-items-center tw-justify-between tw-gap-2">
        <div class="tw-flex tw-items-center tw-gap-2 tw-flex-1 tw-min-w-0">
          <ngx-skeleton-loader count="1" [theme]="theme('20px', '20px')" animation="pulse"></ngx-skeleton-loader>
          <ngx-skeleton-loader count="1" [theme]="theme('60%', '14px')" animation="pulse" class="tw-flex-1"></ngx-skeleton-loader>
        </div>
        <ngx-skeleton-loader count="1" [theme]="theme('24px', '24px', '9999px')" animation="pulse"></ngx-skeleton-loader>
      </div>
      <div class="tw-ml-6">
        <ngx-skeleton-loader count="1" [theme]="theme('56px', '20px')" animation="pulse"></ngx-skeleton-loader>
      </div>
      <div class="tw-flex tw-flex-row tw-gap-4 tw-ml-6">
        <ngx-skeleton-loader count="1" [theme]="theme('100px', '12px')" animation="pulse"></ngx-skeleton-loader>
        <ngx-skeleton-loader count="1" [theme]="theme('120px', '12px')" animation="pulse"></ngx-skeleton-loader>
      </div>
    </div>
  }
</div>
